module.exports = __webpack_public_path__ + "static/nav-contact-6-9db3de93159418551701a86e479180a2.jpg";